module.exports = __webpack_public_path__ + "img/shop-icon-04.ea8e3d78.png";